import React from 'react';

import { connect } from 'react-redux';
import {createFilter} from 'react-search-input';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';

import { fetchProjects, createProject , } from '../../actions/project';
import history from '../../history';
import ProjectList from './ProjectList';
import ProjectSearch from './ProjectSearch';
import ContainerTranslation from "../partials/ContainerTranslation";



class Project extends React.Component {

  constructor(props) {
    super(props);
    const { fetchProjects } = this.props;
    this.user = JSON.parse(localStorage.getItem("user"));
    fetchProjects();
    this.state = {
      searchTerm: '',
      projects : [],
      sortBy : 'alphabetic',
      selectedStartDates : [],
      selectedEndDates : [],
      validationFilter : 'all',
      hseFilter : false,
      rseFilter : false,
      selectedItems : {
        'information':{
          'filiale-country':[],
          'office':[],
          'typology':[],
          'phase':[],
          'name':[],
          'manager':[],
          'program':[],
          'subprogram':[],
          'start-date':[],
          'end-date':[]
        },
        'client':{
          'client':[],
          'subclient':[],
          'client-entity':[],
          'client-subentity':[],
          'supervisor':[],
          'localisation-client-country':[],
          'localisation-client-cp':[],
          'localisation-deploiement-country':[],
          'localisation-deploiement-cp':[]
        },
        'notes':{
          'keywords':[],
          'context':[],
          'objectives':[],
          'activity':[]
        },
        'environnement':{
          'environnement-domain':[],
          'environnement-context':[]
        },
        'tools':[],
        'intervention-level':{
          'intervention-type':[],
          'intervention-mission':[],
          'intervention-application':[]
        },
        'expertise':{
          'domain-competence':[],
          'domain-speciality':[],
          'domain-specificity':[],
          'domain-other':[]
        },
      }
    }
  }

  componentDidUpdate(prevProps,prevState){
    var _this = this
    if(!prevProps.projects.length && this.props.projects.length){
      this.setState({
        projects:_this.props.projects
      })
    }

    if(this.props.message === 'Created Project'){
      history.push('/project/edit/'+this.props.project._id);
    }
    if(prevState.validationFilter !== _this.state.validationFilter ){
      this.filterProjects(this.state.selectedItems)
    }


  }

  setSort(data) {
    this.setState({
      sortBy:data
    })
  }

  setSelectedStartDates(data) {
    this.setState({
      selectedStartDates:data
    })
    this.filterProjects(this.state.selectedItems, data, this.state.selectedEndDates)
  }

  setSelectedEndDates(data) {
    this.setState({
      selectedEndDates:data
    })
    this.filterProjects(this.state.selectedItems, this.state.selectedStartDates, data)
  }

  selectItem(data) {

    let items = this.state.selectedItems

    if(data.name){
      items[data.parent][data.name] = data.value
    }else{
      items[data.parent] = data.value
    }

    const filter = {
      selectedStartDates : this.state.selectedStartDates, 
      selectedEndDates : this.state.selectedEndDates,
      hseFilter : this.state.hseFilter,
      rseFilter : this.state.rseFilter
    }

    this.filterProjects(items, filter)
  }

  
  filterProjects(items, filter = {}){
    var projects = this.props.projects
    _.forEach(items, function(parentItem, parentItemKey){
      if(Array.isArray(parentItem)){
        if(parentItem.length){
          projects = _.filter(projects, function(project){
            var mapProject = project.content[parentItemKey]
            return _.intersection(mapProject, parentItem).length > 0
          })
        }
      }else{
        _.forEach(parentItem, function(item, itemKey){
          if(item.length){
            projects = _.filter(projects, function(project){
              var mapProject = project.content[parentItemKey]
              if(Array.isArray(mapProject)){
                mapProject = _.map(mapProject, itemKey)
                return _.intersection(mapProject, item).length > 0
              }else{
                if(Array.isArray(mapProject[itemKey])){
                  return _.intersection(mapProject[itemKey], item).length > 0
                }else{
                  return item.indexOf(project.content[parentItemKey.toString()][itemKey.toString()]) !== -1
                }
              }

            })
          }
        })
      }
    })

    if(filter.selectedStartDates && filter.selectedStartDates.length > 0){
      projects = _.filter(projects, function(project){
        var startDate = filter.selectedStartDates[0]
        var endDate = filter.selectedStartDates[1]
        if(project.content['information']['start-date']){
          var parseDate = project.content['information']['start-date'].split('/')
          var parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
          return new Date(parseStringDate).getTime() >= new Date(startDate.date).getTime() && new Date(parseStringDate).getTime() <= new Date(endDate.date).getTime()
        }else{
          return false
        }
      })
    }

    if(filter.selectedEndDates && filter.selectedEndDates.length > 0){
      projects = _.filter(projects, function(project){
        var startDate = filter.selectedEndDates[0]
        var endDate = filter.selectedEndDates[1]
        if(project.content['information']['end-date']){
          var parseDate = project.content['information']['end-date'].split('/')
          var parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
          return new Date(parseStringDate).getTime() >= new Date(startDate.date).getTime() && new Date(parseStringDate).getTime() <= new Date(endDate.date).getTime()
        }else{
          return false
        }
      })
    }


    //filter by validation
    if (this.state.validationFilter === "validated"){
      projects = _.filter(projects, function(item){
        return item.validationInformation && item.validationInformation.isValidated;
      })
    }else if (this.state.validationFilter === "not validated"){
      projects = _.filter(projects, function(item){
        return !item.validationInformation || !item.validationInformation.isValidated;
      })
    }else{
      
    }


    if (filter.hseFilter ){
      projects = projects.filter((project)=>project.content.information.isHSE === "true")
    }

    if (filter.rseFilter ){
      projects = projects.filter((project)=>project.content.information.isRSE === "true")
    }


    this.setState({
      selectedItems:items,
      projects:projects
    })
  };

  searchUpdated = (term) => {
    this.setState({searchTerm: term})
  }

  renderProjects() {
    if (this.state.projects.length) {
      let projects = this.state.projects
      if(this.state.sortBy === 'alphabetic'){
        projects = _.sortBy(projects, function(project){
          return project.content['information']['name']
        })
      }
      if(this.state.sortBy === 'startDate'){
        projects = _.sortBy(projects, function(project){
          let value = 0
          if(project.content['information']['start-date']){
            const parseDate = project.content['information']['start-date'].split('/')
            const parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
            value = new Date(parseStringDate).getTime()
          }
          if(isNaN(value)){
            value = 0
          }
          return value
        }).reverse()
      }
      if(this.state.sortBy === 'duration'){
        projects = _.sortBy(projects, function(project){
          let value = 0
          if(project.content['information']['start-date'] && project.content['information']['end-date']){
            const parseStart = project.content['information']['start-date'].split('/');
            const parseStringStart = parseStart[2]+"-"+parseStart[1]+"-"+parseStart[0];
            const parseEnd = project.content['information']['end-date'].split('/');
            const parseStringEnd = parseEnd[2]+"-"+parseEnd[1]+"-"+parseEnd[0];
            value = new Date(parseStringEnd).getTime() - new Date(parseStringStart).getTime()
          }
          if(isNaN(value)){
            value = 0
          }
          return value
        }).reverse()
      }
      if(this.state.sortBy === 'completion'){
        projects = _.sortBy(projects, function(project){
          return project.progression
        }).reverse()
      }
      const KEYS_TO_FILTERS = ['content.information.name']
      return (
        <ProjectList circle={false} items={projects.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS))} translate= {this.props.translate} endpoint= {"/project/"}/>
      );
    }
  }



  createProject() {
    this.props.createProject()
  }


  selectValidationFilter(value){
    if (value === "all"){
      this.setState({
        validationFilter: "all"
      })
    }
    else if (value === "validated") {
      this.setState({
        validationFilter: "validated"
      })
    }
    else {
      this.setState({
        validationFilter: "not validated"
      })      
    }
  }

  handleFilterToggleFactory(path){
    const handleFilterToggle = async (e) => {

      let filter = {
        selectedStartDates : this.state.selectedStartDates, 
        selectedEndDates : this.state.selectedEndDates,
        hseFilter : this.state.hseFilter,
        rseFilter : this.state.rseFilter
      }
      filter[path] = !filter[path]

      this.setState({
        [path]: !this.state[path]
      }) 

      this.filterProjects(this.state.selectedItems, filter)
    }

    return handleFilterToggle.bind(this)
  }

 
  getProgressionColor(progression){
    let color = '#989DA3'
    if (progression > 0) {
      color = '#CF3440'
    }
    if (progression > 25) {
      color = '#CF8B44'
    }
    if (progression > 50) {
      color = '#CFC544'
    }
    if (progression > 75) {
      color = '#99CC66'
    }
    color = '' + color + '';
    return(color);
  }


  render() {

    let expertises = []
    _.each(this.state.projects, function(project){
      _.each(project.content.expertise, function(expertise){
        if(expertise){
          let foundExpertise = _.find(expertises, function(exp){return exp.name === expertise['domain-competence']})
          if(foundExpertise){
            foundExpertise.count += 1
          }else{
            if(expertise['domain-competence']){
              expertises.push({
                name:expertise['domain-competence'],
                count:1,
                index:expertises.length
              })
            }
          }
        }
      })
    })
    expertises = _.orderBy(expertises, 'count').reverse()
    expertises = _.take(expertises, 4)


    let interventionLevel = []
    _.each(this.state.projects, function(project){
      _.each(project.content['intervention-level'], function(intervention){
        let foundIntervention = _.find(interventionLevel, function(int){return int.name === intervention['intervention-type']})
        if(foundIntervention){
          foundIntervention.count += 1
        }else{
          if(intervention['intervention-type']){
            interventionLevel.push({
              name:intervention['intervention-type'],
              count:1,
              index:interventionLevel.length
            })
          }
        }
      })
    })
    interventionLevel = _.orderBy(interventionLevel, 'count').reverse()
    interventionLevel = _.take(interventionLevel, 4)

    let allProgression = 0
    if(this.state.projects && this.state.projects.length){
      allProgression = Math.floor(_.sum(_.map(this.state.projects, 'progression'))/_.map(this.state.projects, 'progression').length)
    }

    let clients = []
    _.each(this.state.projects, function(project){
      let foundClient = _.find(clients, function(client){return client.name === project.content.client.client})
      if(foundClient){
        foundClient.count += 1
      }else{
        if(project.content.client.client){
          clients.push({
            name:project.content.client.client,
            count:1,
            index:clients.length
          })
        }
      }
    })
    clients = _.orderBy(clients, 'count').reverse()
    clients = _.take(clients, 4)

    let startDates = _.map(this.props.projects, function(project){
      if(project.content['information']['start-date']){
        const parseDate = project.content['information']['start-date'].split('/')
        const parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
        return parseStringDate
      }
      return
    })
    startDates = _.compact(startDates)
    startDates = _.uniq(startDates)
    startDates = _.map(startDates, function(date){
      return new Date(date)
    })
    startDates = _.orderBy(startDates, function(date){
      return date.getTime()
    })

    const startDate = startDates[0];
    const endDate = new Date();

    const getMonthArray = function(start, end) {
      let arr = new Array([]);
      let dt = new Date(start);
      while (dt <= end) {
        arr.push(new Date(dt));
        dt.setMonth(dt.getMonth() + 1);
      }
      return arr;
    }

    let dateArr = getMonthArray(startDate, endDate);

    dateArr = _.compact(_.map(dateArr, function(date){
      const parsedDate = new Date(date)
      let month = parsedDate.getMonth()+1
      if(parsedDate.getMonth() <9){
        month = "0"+(parsedDate.getMonth()+1)
      }
      const dateToReturn = month+"/"+parsedDate.getFullYear()
      if(dateToReturn !== "NaN/NaN"){
        return {
          date : parsedDate,
          dateLabel : dateToReturn
        }
      }
    }))

    const progressionColor = this.getProgressionColor(allProgression); 

    const ProjectHSECount = this.state.projects.filter((project => project.content.information.isHSE === "true")).length;
    const ProjectRSECount = this.state.projects.filter((project => project.content.information.isRSE === "true")).length;

    return (
      <div>
            {!Array.isArray(this.props.projects) ? null : (
          <>
            <div className="dashboard-header">
              <h1 className="page-title"><span style={{ fontWeight: 'bold', color: 'rgb(0, 0, 0)' }}>{this.state.projects.length}</span> <ContainerTranslation id={'Page.Project.title'} /></h1>
              <div style={{ "flexDirection": "row" }} >
                {(this.user.role !== "RH") ?
                  <button className="primary-btn" style={{ float: "left", "marginRight": "20px" }} onClick={this.createProject.bind(this)}><ContainerTranslation id={'Page.Project.btn-add'} /></button>

                  :
                  null
                }

              </div>
            </div>
            <div className="tiles">
              <div className="tile">
                {clients.map(client => <div key={Date.now() + "-" + client.index} style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontSize: '14px' }}>{client.count} - </span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(145, 190, 212)' }}>{client.name}</span>
                </div>)}
              </div>
              <div className="tile">
                {expertises.map(expertise => <div key={Date.now() + "-" + expertise.index} style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontSize: '14px' }}>{expertise.count} - </span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)' }}><ContainerTranslation id={['domain-competence'] + "." + [expertise.name]} /></span>
                </div>)}
              </div>
              <div className="tile">
                {interventionLevel.map(intervention => <div key={Date.now() + "-" + intervention.index} style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontSize: '14px' }}>{intervention.count} - </span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)' }}><ContainerTranslation id={['intervention-type'] + "." + [intervention.name]} /></span>
                </div>)}
              </div>
              <div className="tile">
                <div style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color : progressionColor }}>{allProgression} % - </span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)' }}>
                    <ContainerTranslation id={'Page.Project.' + ['average completion']} />
                  </span>
                </div>
                <div style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontSize: '14px' }}>{ProjectHSECount} - </span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)' }}>
                    {`${this.props.translate("Page.Project.title")} HSE`}
                  </span>
                </div>
                <div style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontSize: '14px' }}>{ProjectRSECount} - </span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)' }}>
                    {`${this.props.translate("Page.Project.title")} RSE`}
                  </span>
                </div>
              </div>
            </div>

            <ProjectSearch
              searchUpdated={this.searchUpdated}
              projects={this.state.projects}
              selectedItems={this.state.selectedItems}
              selectItem={this.selectItem.bind(this)}
              setSort={this.setSort.bind(this)}
              setSelectedStartDates={this.setSelectedStartDates.bind(this)}
              setSelectedEndDates={this.setSelectedEndDates.bind(this)}
              dates={dateArr}
              selectValidationFilter = {this.selectValidationFilter.bind(this)}
              handleFilterToggleFactory = {this.handleFilterToggleFactory.bind(this)}
            />

            <div className="page-container">
              {this.renderProjects()}
            </div>
          </>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projects: state.project.projects,
    message: state.project.message,
    project:state.project.project
  };
}

export default connect(mapStateToProps, {fetchProjects, createProject})(withLocalize(Project));
